
import { defineComponent, toRefs, reactive, watch, ref } from "vue";
import type { FormRules, FormInstance } from "element-plus";
interface Props {
  dialogVisible: boolean;
}
interface State {
  visible: boolean;
}

// 使用：
//  <GoogleDialogue v-model:dialogVisible="gooleshow" @changeNavfu="onconfirm"></GoogleDialogue>
//     const commitFn = () => {
//       gooleshow.value = !gooleshow.value;
//     };
//     const gooleId = ref("");
//     const onconfirm = (val: any) => {
//       let gId = val.ruleForm.gooleId;
//       gooleId.value = gId;
//       commitFn();
//     };

export default defineComponent({
  name: "Dialog",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "编辑提示",
    },
    text: {
      type: String,
      default: "说明: 本次操作需要验证身份，请向管理员索要谷歌动态口令进行操作",
    },
  },
  setup(props, context) {
    const ruleFormRef = ref<FormInstance>();
    let text = props.text ? props.text : "说明: 本次操作需要验证身份，请向管理员索要谷歌动态口令进行操作";
    let header = props.title ? props.title : "编辑提示";
    const textRem = ref(text);
    const title = ref(header);
    const { dialogVisible } = toRefs(props as Props);
    const parent = { ...context };
    const state = reactive<State>({
      visible: dialogVisible.value,
    });
    watch(
      dialogVisible,
      (newValue) => {
        state.visible = newValue;
      },
      { immediate: true }
    );
    const onClose = () => {
      parent.emit("update:dialogVisible", false);
      parent.emit("onClose", onClose);
      ruleForm.gooleId = "";
    };
    // const onConfirm = () => {

    // };

    const ruleForm = reactive({ gooleId: "" });
    const rules = reactive<FormRules>({
      gooleId: [{ required: true, message: "请输入谷歌验证码", trigger: "blur" }],
    });

    const onConfirm = async (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      await formEl.validate((valid, fields) => {
        if (valid) {
          parent.emit("changeNavfu", { ruleForm });
        } else {
          console.log("error submit!", fields);
        }
      });
      ruleForm.gooleId = "";
    };

    const onCloseFn = () => {
      parent.emit("onCloseFn", state.visible);
      onClose();
    };

    return {
      onCloseFn,
      ...toRefs(state),
      onClose,
      onConfirm,
      textRem,
      ruleForm,
      rules,
      ruleFormRef,
    };
  },
});
